























import { Component, Vue, Prop, PropSync } from "vue-property-decorator";

@Component
class WyreFiatAmountInput extends Vue {
  @Prop() fiatAsset;

  @Prop() quotation;

  @Prop() cryptoAsset;

  @PropSync("fiatAmount") bindFiatAmount!: string;

  get meta() {
    const fiatSymbol = this.fiatAsset?.unit ?? "";
    const cryptoSymbol = this.cryptoAsset?.symbol ?? "";
    const destAmount = this.quotation?.destAmount ?? "";
    return {
      label: fiatSymbol,
      cryptoSymbol,
      destAmount
    };
  }

  get styles() {
    const len = this.bindFiatAmount?.length ?? 0;
    const fontSize = len > 8 ? 38 : len > 4 ? 42 : 48;
    const charWidth = len > 8 ? 26 : len > 4 ? 30 : 34;
    const width = len * charWidth;
    return {
      width: `${width}px`,
      fontSize: `${fontSize}px`
    };
  }

  handleInput(e) {
    this.bindFiatAmount = e.target.value;
  }

  handelBlur() {
    if (this.bindFiatAmount === "") {
      this.bindFiatAmount = "0";
    }
  }

  handleFocus() {
    if (this.bindFiatAmount === "0") {
      this.bindFiatAmount = "";
    }
  }

  handleFocusInput() {
    const input = this.$refs.input as any;
    input.focus();
  }
}
export default WyreFiatAmountInput;
